import * as Icons from '@ant-design/icons';
import { Button, Drawer, Flex, Table, Typography } from 'antd';
import { TagField } from '@refinedev/antd';
import { formatDate } from 'services/date';
import { useCertificateStore } from '../../certificate.store';
import { useList } from '@refinedev/core';
import { useMemo } from 'react';

export const DrawerApprovesHistory = () => {
  const {
    drawers: { approvesHistory },
    closeApprovesHistoryDrawer,
    enrollment,
    openObservationModal
  } = useCertificateStore();

  const { data: certificationApprovals, isLoading } = useList({
    resource: `graduate/courses/enrollments/${enrollment?.id}/certification_approvals/change_logs`
  });

  const filteredCertificationApprovals = useMemo(() => {
    return (
      certificationApprovals?.data?.filter(
        approval => !(approval.approved === null && approval.event === 'update')
      ) || []
    );
  }, [certificationApprovals]);

  return (
    <>
      <Drawer
        closable={false}
        closeIcon={false}
        open={approvesHistory}
        onClose={() => closeApprovesHistoryDrawer()}
        width={800}
        title={
          <Flex vertical>
            <Typography.Title level={4} className="!mb-0">
              Histórico de aprovações
            </Typography.Title>
            <Typography.Text type="secondary" className="font-normal">
              Acompanhe o histórico de todas as aprovações concedidas
            </Typography.Text>
          </Flex>
        }
        extra={
          <Button
            color="default"
            icon={<Icons.CloseOutlined />}
            onClick={() => closeApprovesHistoryDrawer()}
          ></Button>
        }
      >
        <Table
          rowKey="id"
          dataSource={filteredCertificationApprovals}
          loading={isLoading}
        >
          <Table.Column
            title="Status"
            dataIndex="approved"
            key="date"
            render={value => (
              <TagField
                value={value ? 'Aprovado' : 'Reprovado'}
                color={value ? 'success' : 'error'}
              />
            )}
          />
          <Table.Column
            title="Autor"
            dataIndex={['author', 'name']}
            key="status"
          />
          <Table.Column
            title="Setor"
            dataIndex="kind"
            key="user"
            render={value => (value === 'csc' ? 'Reguladora' : 'Secretaria')}
          />
          <Table.Column
            title="Data"
            dataIndex="created_at"
            key="user"
            render={value => formatDate(value, 'DD/MM/YYYY - HH:mm')}
          />
          <Table.Column
            title="Justificativa"
            dataIndex="observation"
            key="user"
            render={(_, record) =>
              !record.approved && (
                <Button
                  onClick={() =>
                    openObservationModal(
                      'Justificativa de rejeição',
                      record.created_at,
                      record.author.name,
                      record.observation
                    )
                  }
                >
                  Visualizar
                </Button>
              )
            }
          />
        </Table>
      </Drawer>
    </>
  );
};
